import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Cue5050Site } from '../../_models/fundraising/Cue5050Site';
import { getUrl } from '../../_shared/utils';
import { JWTTokenService } from '../jwtToken.service';
import { FundraisingSiteService } from './fundraisingSite.service';

@Injectable()
export class Cue5050SiteService extends FundraisingSiteService {

    constructor(
        protected http: HttpClient,
        protected jwtTokenService: JWTTokenService) 
        {
            super(http, jwtTokenService);
        }

    
    public getSiteData(): Observable<Cue5050Site> {
        return this.http.get<Cue5050Site>(getUrl('fundraising/cue5050/site/customize'), this.requestOptionsAuthenticated('portal'));
    }

    public create(data: Cue5050Site): Observable<Cue5050Site> {
        return this.http.post<Cue5050Site>(getUrl('fundraising/cue5050/site/customize/create'), data, this.requestOptionsAuthenticated('portal'));
    }

    public update(data: Cue5050Site): Observable<Cue5050Site> {
        return this.http.post<Cue5050Site>(getUrl('fundraising/cue5050/site/customize/update'), data, this.requestOptionsAuthenticated('portal'));
    }

    public getHostnameAvailability(name: string): Observable<any> {
        return this.http.get(getUrl(`fundraising/cue5050/site/customize/availability?name=${name}`), this.requestOptionsAuthenticated('portal'));
    }

    public deleteLegalPdf(objectPath: string): Observable<boolean> {
        const s3Object = { objectPath };
        return this.http.post<boolean>(getUrl('fundraising/cue5050/site/delete-pdf'), s3Object, this.requestOptionsAuthenticated('portal'));
    }  
}